import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "../client";

export const useBrandCreators = (merchantId: string) => {
  return useQuery({
    queryKey: ["admin", "brand-creators", merchantId],
    queryFn: async () => {
      const res = await client.admin["brand-creators"][":merchantId"].$get({
        param: { merchantId },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
